/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Menu_Unknown_DeveloperInputs */

const en_dev_menu_unknown_developer = /** @type {(inputs: Dev_Menu_Unknown_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown Developer`)
};

const ar_dev_menu_unknown_developer = /** @type {(inputs: Dev_Menu_Unknown_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطوّر غير معروف`)
};

const bn_dev_menu_unknown_developer = /** @type {(inputs: Dev_Menu_Unknown_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অজানা ডেভেলপার`)
};

const de_dev_menu_unknown_developer = /** @type {(inputs: Dev_Menu_Unknown_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannter Entwickler`)
};

const es_dev_menu_unknown_developer = /** @type {(inputs: Dev_Menu_Unknown_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador desconocido`)
};

const fr_dev_menu_unknown_developer = /** @type {(inputs: Dev_Menu_Unknown_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur inconnu`)
};

const pt_dev_menu_unknown_developer = /** @type {(inputs: Dev_Menu_Unknown_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor desconhecido`)
};

const zh_dev_menu_unknown_developer = /** @type {(inputs: Dev_Menu_Unknown_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知开发者`)
};

const tr_dev_menu_unknown_developer = /** @type {(inputs: Dev_Menu_Unknown_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilinmeyen Geliştirici`)
};

const ru_dev_menu_unknown_developer = /** @type {(inputs: Dev_Menu_Unknown_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестный разработчик`)
};

const pl_dev_menu_unknown_developer = /** @type {(inputs: Dev_Menu_Unknown_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieznany programista`)
};

/**
* | output |
* | --- |
* | "Unknown Developer" |
*
* @param {Dev_Menu_Unknown_DeveloperInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dev_menu_unknown_developer = /** @type {((inputs?: Dev_Menu_Unknown_DeveloperInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Menu_Unknown_DeveloperInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dev_menu_unknown_developer(inputs)
	if (locale === "bn") return bn_dev_menu_unknown_developer(inputs)
	if (locale === "de") return de_dev_menu_unknown_developer(inputs)
	if (locale === "es") return es_dev_menu_unknown_developer(inputs)
	if (locale === "fr") return fr_dev_menu_unknown_developer(inputs)
	if (locale === "pt") return pt_dev_menu_unknown_developer(inputs)
	if (locale === "zh") return zh_dev_menu_unknown_developer(inputs)
	if (locale === "tr") return tr_dev_menu_unknown_developer(inputs)
	if (locale === "ru") return ru_dev_menu_unknown_developer(inputs)
	if (locale === "pl") return pl_dev_menu_unknown_developer(inputs)
	return en_dev_menu_unknown_developer(inputs)
});